import React from "react";
import { useT } from "@/lib/LanguageContext";
import useRole from "../hooks/useRole";
import EmptyState from "./EmptyState";

/**
 * Renders `children` only for a role that may perform `action` (roles.js); otherwise a
 * plain statement that the page belongs to the practice owner. The server refuses the
 * same action with 403 CRM_OWNER_ONLY — this only spares the helper the dead end.
 */
export default function RoleGate({ action, children }) {
  const t = useT("crm");
  const { can } = useRole();
  if (can(action)) return children;
  return <EmptyState testId="crm-role-gate" title={t("role.ownerOnlyTitle")} body={t("role.ownerOnlyBody")} />;
}
